import { render, staticRenderFns } from "./companySqlPassword.vue?vue&type=template&id=ba0f4b34&"
import script from "./companySqlPassword.vue?vue&type=script&lang=js&"
export * from "./companySqlPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports